import { put, takeEvery, all, select } from 'redux-saga/effects';
import { API_URL } from 'containers/App/constants';
import { GET_FILTERS } from './constants';
import { filtersLoaded, setLoading, unsetLoading } from './actions';
import { makeSelectLoading, makeSelectSelectedParams } from './selectors';
import { makeSelectSelectedTags } from 'components/HorizontalFilter/selectors';
import { tagsLoaded, sortsLoaded } from '../HorizontalFilter/actions';
import { getRequestHeadersAsLogged, responseHandler } from '../../utils/auth';

function* fetchFilters() {
  const isLoading = yield select(makeSelectLoading());

  if (!isLoading) {
    yield put(setLoading())

    const requestURL = `${API_URL}search/filters`;
    let requestBody = {};

    const params = yield select(makeSelectSelectedParams());
    const requestParams = [];
    params.map(param => (requestParams[param.name] = param.value));

    const tags = yield select(makeSelectSelectedTags());
    const requestTags = [];
    tags.map(tag => requestTags.push(tag.value));

    requestBody = {
      ...requestParams,
      tags: requestTags,
    };

    try {
      const parameters = {
        method: 'POST',
        headers: getRequestHeadersAsLogged(),
        body: JSON.stringify(requestBody),
      };

      const response = yield fetch(requestURL, parameters).then(resp => responseHandler(resp));

      yield all([
        put(filtersLoaded(response.filters)),
        put(tagsLoaded(response.tags)),
        put(sortsLoaded(response.orders)),
        put(unsetLoading()),
      ]);
    } catch (error) {
      console.log('request error', error);
      yield put(unsetLoading())
    }
  }
}

function* actionWatcher() {
  yield takeEvery(GET_FILTERS, fetchFilters);
}

export default function* optionData() {
  yield all([actionWatcher()]);
}
